import { generateEventsFromEnum } from '@guiker/event'

import { BaseTenantPreferenceEvent } from '../base-event'
import { EventTypes } from './event-types'

export const TenantPreferenceEvents = generateEventsFromEnum({
  ...BaseTenantPreferenceEvent,
  entity: 'TENANT_PREFERENCE',
})(EventTypes)
